export const COLORS = {
  HoverNFocus: '#4FCEFD',
  white: '#ffffff',
  appFog100: '#F5F7F7',
  appFog500: '#A3A4A5',
  appFog700: '#565858',
  appFog800: '#353636',
  footerHeader: '#00658C',
  colorHeaderRow: '#41484D',
  subtotalTaxDiscount: '#001E2D',
  borderColor: '#13BCD5',
  cellColor: '#00283ADD',
  borderBottomColor: 'rgba(224, 229, 231, 1)',
  disabledIcon: '#191C1E14',
  iconBgColor: 'rgba(0, 0, 0, 0.04)',
  greyedBackgroundColor: '#DDE3EA',
  grey900: '#212121',
  disabledTiptapIcon: 'rgba(0, 0, 0, 0.26)',
  divider: 'rgba(0, 40, 58, 0.15)',
  tableHeaderBg: '#ECEFF1',
  tableTextColor: '#1F4252',
  columnHoverBg: '#A3EEFF',
  columnHoverBgTransparent: 'rgba(163, 238, 255, 0.3)',
  placeholderGrey: '#bdbdbd',
  sidePanelTabHoverBg: 'rgba(0, 184, 209, 0.08)',
  sidePanelTabSelectedBg: 'rgba(0, 184, 209, 0.08)',
  sidePanelTabBorder: 'rgba(0, 0, 0, 0.12)',
  sidePanelTabFocus: 'rgba(0, 185, 209, 0.3)',
  paleBlue300: '#ECF7FA',
  error: '#F23D5E',
};
